import { createFileRoute } from "@tanstack/react-router"

import { UsersList } from "@/features/users/users-list"

export const Route = createFileRoute("/users")({ component: UsersScreen })

/**
 * Thin on purpose: a TanStack route file may export nothing but its `Route`,
 * so everything worth testing lives in the feature.
 *
 * No role guard here, exactly as `/imports` and `/feedback` have none. The
 * screen stays reachable by URL, the navigation entry is Administrator-only,
 * and every endpoint behind it refuses anybody else, which the list surfaces as
 * its error state. A guard in the client would be a second, weaker copy of a
 * rule the server already enforces.
 */
function UsersScreen() {
  return <UsersList />
}
